<div class="plausi-container">
	<!-- Cross-Projekt-Hinweis: Punkt gehört zu einem anderen Projekt → von hier aus
	     nur lesbar; Workflow wird im zuständigen Projekt bearbeitet (Einfachmodell).
	     Bei abgeschlossenem Fremdpunkt zeigt bereits der Parent-Frozen-Banner den
	     Projektnamen — hier nicht doppeln. -->
	@if (foreignProject && !isPointFrozen) {
		<div class="alert alert-secondary d-flex align-items-center gap-2 mb-2 py-2">
			<i class="bi bi-folder2-open"></i>
			<span class="flex-grow-1">
				@if (fremdesProjektName; as name) {
					Dieser Punkt gehört zum Projekt „{{ name }}" — hier ist er nur lesbar.
					Öffnen Sie „{{ name }}", um seinen Status zu ändern.
				} @else {
					<!-- Datennutzer/Betrachter sehen keine Projektnamen (wie im Sperr-Banner). -->
					Dieser Punkt gehört zu einem anderen Projekt — hier ist er nur lesbar.
				}
			</span>
		</div>
	}

	<!-- Zeile 2: Letzte Bearbeitung — Name und Zeitpunkt, nicht fuer Datennutzer -->
	@if (bp.lastModified && !personenVerborgen) {
		<div class="info-row mb-2">
			<i class="bi bi-clock-history"></i>
			<span>Zuletzt bearbeitet: {{ formatLastModified(bp.lastModified) }}</span>
		</div>
	}

	<!-- Zeile 3: Import-Info — Zeitpunkt, Importeur und Dateiname, nicht fuer Datennutzer -->
	@if (bp.importInfo && !personenVerborgen) {
		<div class="info-row mb-3">
			<i class="bi bi-box-arrow-in-down"></i>
			<span>
				Importiert am {{ formatImportTime(bp.importInfo.time) }}
				@if (bp.importInfo.user) {
					von <strong>{{ bp.importInfo.user }}</strong>
				}
				@if (bp.importInfo.source) {
					aus <em>{{ bp.importInfo.source }}</em>
				}
				@if (bp.importInfo.coordTransform) {
					<br><small class="text-muted">Koordinaten: {{ bp.importInfo.coordTransform }}</small>
				}
			</span>
		</div>
	}

	<!-- Bereich 1: Fehlermeldungen und Warnungen (klappbar) -->
	<div class="plausi-section" *ngIf="vs.hasMessages()">
		<div class="section-header" (click)="messagesCollapsed = !messagesCollapsed">
			<i class="bi" [ngClass]="messagesCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'"></i>
			<i class="bi bi-exclamation-triangle"></i>
			<span>Fehlermeldungen und Warnungen</span>
			<span class="badge bg-secondary ms-2">{{ (vs.danger_ | keyvalue).length + (vs.warning_ | keyvalue).length + (vs.message_ | keyvalue).length }}</span>
		</div>
		<div class="section-content" [ngClass]="{ 'collapsed': messagesCollapsed }">
			<div class="section-scrollable">
				<!-- Fehler (danger) -->
				<div class="plausi-item danger" *ngFor="let e of vs.danger_ | keyvalue">
					<div class="item-icon"><i class="bi bi-x-circle-fill"></i></div>
					<div class="item-label">{{displayString(e.key)}}</div>
					<div class="item-message">{{e.value}}</div>
				</div>
				<!-- Warnungen -->
				<div class="plausi-item warning" *ngFor="let e of vs.warning_ | keyvalue">
					<div class="item-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
					<div class="item-label">{{displayString(e.key)}}</div>
					<div class="item-message">{{e.value}}</div>
				</div>
				<!-- Hinweise -->
				<div class="plausi-item info" *ngFor="let e of vs.message_ | keyvalue">
					<div class="item-icon"><i class="bi bi-info-circle-fill"></i></div>
					<div class="item-label">{{displayString(e.key)}}</div>
					<div class="item-message">{{e.value}}</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Bereich 2: Kommentare (klappbar) -->
	<div class="plausi-section" *ngIf="vs.hasCheckerComments()">
		<div class="section-header" (click)="commentsCollapsed = !commentsCollapsed">
			<i class="bi" [ngClass]="commentsCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'"></i>
			<i class="bi bi-chat-left-text"></i>
			<span>Kommentare aus der Kontrolle</span>
			<span class="badge bg-secondary ms-2">{{ commentsCount }}</span>
		</div>
		<div class="section-content" [ngClass]="{ 'collapsed': commentsCollapsed }">
			<div class="section-scrollable">
				<div class="comment-item" *ngFor="let e of vs.checkerComments() | keyvalue"
					[ngClass]="{ 'danger': e.value.type === ValRes.danger, 'warning': e.value.type === ValRes.warning, 'ok': e.value.type === ValRes.ok }">
					<div class="comment-header">
						<span class="comment-label">{{displayString(e.key)}}</span>
						<button class="btn btn-sm comment-btn" [ngClass]="commentsClass(e.value, 'btn-')" (click)="onCommentsClicked(e.key, e.value)">
							<i class="bi bi-chat-left-text"></i>
						</button>
					</div>
					<div class="comment-content">
						<wd-comments [name]="e.key" [comments]="e.value"></wd-comments>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Bereich 3: Workflow-Verlauf (klappbar) -->
	<div class="plausi-section" *ngIf="showWorkflowSection">
		<div class="section-header" (click)="workflowCollapsed = !workflowCollapsed">
			<i class="bi" [ngClass]="workflowCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'"></i>
			<i class="bi bi-clock-history"></i>
			<span>Workflow-Verlauf</span>
			<span class="badge bg-secondary ms-2">{{ workflowHistoryCount }}</span>
		</div>
		<div class="section-content" [ngClass]="{ 'collapsed': workflowCollapsed }">
			<!-- Status + Aktions-Buttons direkt im Verlauf, statt im Tabs-Header. -->
			@if (currentBadge || bp.workflow === undefined || availableTransitions.length > 0 || canReopen || canZuruecknehmen) {
				<div class="workflow-actions d-flex align-items-center flex-wrap gap-2 mb-2">
					@if (currentBadge) {
						<button type="button" class="btn p-0 border-0 align-baseline"
							(click)="onShowDiagram()"
							[title]="'Workflow-Status: ' + currentBadge.label + ' — Klick öffnet das Diagramm/die Übersicht'">
							<span class="badge {{currentBadge.bgClass}} {{currentBadge.textClass || ''}}">
								<i class="bi bi-{{ currentBadge.icon }}"></i> {{ currentBadge.label }}
							</span>
						</button>
					} @else if (bp.workflow === undefined) {
						<button type="button" class="btn p-0 border-0 align-baseline"
							(click)="onShowDiagram()"
							title="Bestandsdaten ohne Workflow-Status — Klick öffnet das Diagramm/die Übersicht">
							<span class="badge bg-light text-muted border">Kein Status</span>
						</button>
					}
					@if (availableTransitions.length > 0 || canReopen || canZuruecknehmen) {
						<!-- Trenner „aktueller Status → mögliche Aktionen": die folgenden
						     Buttons sind Status-Wechsel (Outline), nicht der Status selbst. -->
						<span class="workflow-action-sep text-muted small d-inline-flex align-items-center" aria-hidden="true">
							<i class="bi bi-arrow-right"></i>
							<span class="ms-1 d-none d-md-inline">Status ändern:</span>
						</span>
					}
					@for (target of availableTransitions; track target) {
						<button type="button"
							class="btn btn-sm {{ transitionButtonClass(target) }}"
							[title]="transitionButtonLabel(currentStatus, target)"
							(click)="onTransition(target)">
							<i class="bi bi-{{ statusBadgeFor(target)?.icon ?? 'arrow-right' }}"></i>
							<span class="ms-1">{{ transitionButtonLabel(currentStatus, target) }}</span>
						</button>
					}
					@if (canReopen) {
						<!-- Reopen-Ziel = in_pruefung → info-cyan (kontroll-naher Akzent),
						     konsistent mit den anderen Reopen-Aktionen im Workflow-Editor. -->
						<button type="button" class="btn btn-sm btn-outline-info"
							title="Diesen Punkt zurück in die Kontrolle holen (in Prüfung) — als Projekt-Kontrolleur"
							(click)="onReopen()">
							<i class="bi bi-arrow-repeat"></i>
							<span class="ms-1">Zurück in die Kontrolle</span>
						</button>
					}
					@if (canZuruecknehmen) {
						<!-- Übernahme zurücknehmen (anstehend → abgeschlossen): Umkehrung der
						     „In dieses Projekt übernehmen"-Aktion. Zurück aufs vorige Projekt
						     (oder Bestand). Manager/Entwickler. Ziel = abgeschlossen → success-grün. -->
						<button type="button" class="btn btn-sm btn-outline-success"
							title="Die Übernahme dieses Punkts zurücknehmen — zurück auf „Abgeschlossen“ und ins vorige Projekt (oder Bestand, falls es das Projekt nicht mehr gibt)"
							(click)="onZuruecknehmen()">
							<i class="bi bi-arrow-counterclockwise"></i>
							<span class="ms-1">Übernahme zurücknehmen</span>
						</button>
					}
				</div>
			}
			<div class="section-scrollable">
				<wd-workflow-history [doc]="bp"></wd-workflow-history>
			</div>
		</div>
	</div>

	<!-- Keine Meldungen -->
	<div class="plausi-empty" *ngIf="!vs.hasAny() && !showWorkflowSection">
		<i class="bi bi-check-circle"></i>
		<span>Keine Meldungen oder Kommentare vorhanden.</span>
	</div>
</div>
